import { BookInterface } from "../../books/types/book";
import { useEffect, useRef } from "react"
import { getBookContent, parseContent } from "../../books/utils/formatters";


interface BookContentProps {
    book: BookInterface;
}

const BookContent = ({ book}: BookContentProps) =>{
    const contentRef = useRef<HTMLDivElement>(null)
    const fadeRef = useRef<HTMLDivElement>(null)
    
    useEffect(() => {
        const content = contentRef.current
        const fade = fadeRef.current
        if (content) {
            content.scrollTop = 0
        }
        if (!content || !fade) return

        const checkScroll = () => {
            const { scrollHeight, scrollTop, clientHeight } = content
            const shouldHideFade = scrollHeight <= clientHeight || 
            (scrollHeight - scrollTop - clientHeight <= 10)
            fade.classList.toggle("hidden", shouldHideFade)
        }
        checkScroll()
        content.addEventListener("scroll", checkScroll)
        return () => content.removeEventListener("scroll", checkScroll)
    }, [book])


    const content = getBookContent(book.positioning, book.flapcopy, book.keynote, book.jacketquotes);
const parsedContent = content ? parseContent(content) : null;
return(
    <div className="content-wrapper" data-testid="content-wrapper">
    <div ref={contentRef} className="scrollable-content" data-testid="scrollable-content">
        <div className="content-text" data-testid="content-text">

        {parsedContent}
        <div className="mobile-bottom-padding" data-testid="mobile-bottom-padding"></div>

        </div>
    </div>
    <div ref={fadeRef} className="fade-overlay" data-testid="fade-overlay" />
  </div>
)
}

export default BookContent